import React, { useState, useEffect } from "react";
import { styled } from "../../stitches.config";
import Cookies from "cookies-js"

import ArticleLinks from "./ArticleLinks";
import Timer from '../common/Timer'
import BridVoteButton from './BridVoteButton'

import { bridVote } from './bridVote'

const BridTileNarrow = props => {
  const { article } = props;
  const [percentage, setPercentage] = useState(null);
  const [voted, setVoted] = useState(null);
  const [hasCookie, setHasCookie] = useState(false)
  const imageHeight = (props.imageHeight ? props.imageHeight : (window.innerWidth > 991 ? 456 : 846));
  const articlesGroup = [article.article1_id, article.article2_id, article.article3_id]
  var imgUrl = article.picture.img;
  imgUrl = imgUrl.replace("780,0,0,0", "0," + imageHeight + ",0,0");

  useEffect(() => {
    const value = Cookies.get("_brid");
    if (typeof value === "string") {
      const [blockID, articleID] = value.split(".");
      setHasCookie(true)
      if (blockID === props.uID) {
        setVoted(articleID)
      }
    }
  }, [])


  const fetchVotes = async (ID) => {
    const votes = await bridVote(ID, articlesGroup)
      .catch(err => console.log(err))

    if (votes) {
      setPercentage(votes.data?.articlesAverage);
      setVoted(ID);
      if (props.uID) Cookies.set('_brid', `${props.uID}.${ID}`, { expires: 86400 })
    }
  }

  return (
    <BoxWrapper
      css={{
        "$$bg": imgUrl,
        "$$imageHeight": imageHeight + 'px',
        "$$preserveImageRatio": props.preserveImageRatio
      }}
    >
      <ImageWrapper
        css={{
          "$$imageHeight": imageHeight + 'px'
        }}
        preserveImageRatio={props.preserveImageRatio}>
        <Overlay>
          <img alt="" src={imgUrl} className="preserveImageRatioImage" />
        </Overlay>
      </ImageWrapper>
      <Footer className={article.show_links && article.show_links != 'off' ? 'show-links' : null} size={props.size}>
        <Donate>
          Wybierz projekt do realizacji:
        </Donate>
        <Title className="text-on-picture__title" size={props.size}>
          {article.title}
        </Title>
        <TimeLeft>Pozostały czas głosowania: <Timer finishTime={article.time} /></TimeLeft>
        <Topic>
          Tematy do wyboru:
        </Topic>
        <ArticleLinks links={article.links} show={article.show_links} />
      </Footer>
      <VoteButtons>
        <BridVoteButton
          title_normal={article.title_button1}
          articleID={article.article1_id}
          percentage={percentage}
          voted={voted}
          hasCookie={hasCookie}
          fetchVotes={fetchVotes}
          votingResult={props.votingResult}
        />
        <BridVoteButton
          title_normal={article.title_button2}
          articleID={article.article2_id}
          percentage={percentage}
          voted={voted}
          hasCookie={hasCookie}
          fetchVotes={fetchVotes}
          votingResult={props.votingResult}
        />
        <BridVoteButton
          title_normal={article.title_button3}
          articleID={article.article3_id}
          percentage={percentage}
          voted={voted}
          hasCookie={hasCookie}
          fetchVotes={fetchVotes}
          votingResult={props.votingResult}
        />
      </VoteButtons>
    </BoxWrapper>
  );
};

const VoteButtons = styled("div", {
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  height: "350px",
  left: "18px",
  right: "18px",
  bottom: "0",
  zIndex: 2,
  "@media (min-width: 992px)": {
    flexDirection: "row",
    left: "30px",
    height: "100px",
    bottom: "30px"
  }
});

const TimeLeft = styled("p", {
  fontSize: "20px",
  fontWeight: 300,
  color: "#f4f6fc",
  margin: "10px 0 30px 0"
});

const Overlay = styled("div", {
  height: "auto",
  overflow: "hidden",
  background: "linear-gradient(to top, #000000, rgba(80, 73, 70, 0.26) 57%, rgba(44, 44, 44, 0))",
  "& > img": {
    zIndex: -1,
    position: "relative"
  }
});

const Title = styled("span", {
  lineHeight: "30px",
  display: "block",
  position: "relative",
  pointerEvents: "none",
  fontSize: "34px",
  fontWeight: 300,
  fontStretch: "normal",
  fontStyle: "normal",
  letterSpacing: "normal",
  color: "#f4f6fc",
  width: "90%",
  "@media (min-width: 992px)": {
    width: "632px"
  }
});

const BoxWrapper = styled("div", {
  margin: "12px 0",
  position: "relative",
  minHeight: "$$imageHeight",
  display: "flex",
  background: "linear-gradient(to top, #000000, rgba(80, 73, 70, 0.26) 57%, rgba(44, 44, 44, 0)), url($$bg) no-repeat center center",
  backgroundSize: "cover",
  "> a": {
    display: "block",
    textDecoration: "none",
    position: "absolute",
    zIndex: 1,
    left: "0",
    right: "0",
    top: "0",
    bottom: "0",
    minWidth: "100%",
    "@media (min-width: 992px)": {
      position: "absolute"
    }
  },
  varinats: {
    "preserveImageRatio": {
      true: {
        "& > a": {
          "@media (min-width: 992px)": {
            position: "static"
          }
        }
      },
      false: {}
    }
  }
});

const ImageWrapper = styled("span", {
  ".preserveImageRatioImage": { display: "none" },
  "@media (min-width: 992px)": {
    display: "block",
    ".preserveImageRatioImage": {
      width: "100%",
      display: "none",
      minHeight: "$$imageHeight"
    }
  },
  variants: {
    "preserveImageRatio": {
      true: {
        "@media (min-width: 992px)": {
          ".preserveImageRatioImage": {
            display: "block",
            minHeight: "150px"
          }
        },
      },
      false: {}
    }
  }
});


const Footer = styled("span", {
  display: "block",
  alignSelf: "flex-end",
  zIndex: 2,
  pointerEvents: "none",
  position: "absolute",
  left: "18px",
  bottom: "360px",
  right: "0",
  "@media (min-width: 992px)": {
    left: "30px",
    bottom: "134px",
    "&.show-links": {
      paddingLeft: "250px"
    }
  }
});

const Donate = styled("div",{
  marginBottom: "10px",
  fontSize: "18px",
  fontWeight: 500,
  color: "#f4f6fc",
  zIndex: 3
});

const Topic = styled(Donate,{
  fontSize: "15px",
  color: "#eef3f5"
});

export default BridTileNarrow;
